import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import React from 'react';

const MobileAnonymousUserNavbar = ({ info }: { info: any }, auth: boolean ) => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  return (
 
          <div className=" space-y-2 py-6">
            {/* Home */}
            <Link 
              className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
              data-te-nav-link-ref
              data-te-ripple-init
              data-te-ripple-color="light"
              onClick={() => info(false)} to="/home">{t('Home')}</Link>

            {/* Articles */}
            <Link 
              className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
              data-te-nav-link-ref
              data-te-ripple-init
              data-te-ripple-color="light"
              onClick={() => info(false)} to="/published-articles">{t('Articles')}</Link>

            {/* Videos */}
            <Link 
              className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
              data-te-nav-link-ref
              data-te-ripple-init
              data-te-ripple-color="light"
              onClick={() => info(false)} to="/videos">{t('Videos')}</Link>

            {/* About */}
            <Link className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
                  data-te-nav-link-ref
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  onClick={() => info(false)} to="/about">{t('About')}</Link>

            {/* Contact */}
            <Link className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
                  data-te-nav-link-ref
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  onClick={() => info(false)} to="/contact">{t('Contact')}</Link>

          </div>
  
  )
};

export default MobileAnonymousUserNavbar;
